<template>
  <side-panel
    v-if="isInitialized"
    :class="['global-side-panel', customClasses]"
    :is-visible="isVisible"
    @closeSidePanel="isVisible = false"
  >
    <dynamic-template
      :html="content"
    />
  </side-panel>
</template>

<script lang="ts">
  declare global {
    interface Window { sidePanel: Function; }
  }
</script>

<script setup lang="ts">
  import {defineAsyncComponent, ref} from 'vue';
  import httpRequest from '@/bps/utilities/js/httpRequest/httpRequest';

  const SidePanel = defineAsyncComponent(() => import('@/bps/components/sidePanel/SidePanel.vue'));
  const DynamicTemplate = defineAsyncComponent(() => import('@/bps/components/dynamicTemplate/dynamicTemplate.vue'));

  // Global function, accessible from everywhere (<a href="javascript:sidePanel('https://someUrl/', 'class1 class2')">)
  window.sidePanel = (url: string, additionalClasses: string = '') => {
    customClasses.value = additionalClasses;
    loadContentFromUrl(url);
  };

  const content = ref('');
  const isInitialized = ref(false);
  const isVisible = ref(false);
  const customClasses = ref('');

  function loadContentFromUrl(url: string) {
    isInitialized.value = true;
    isVisible.value = true;
    content.value = '<div class="loader"></div>';

    httpRequest.get(url)
      .then(response => {
        content.value = response.data;
      })
      .catch()
      .finally();
  }
</script>
